import ItemProvider from './ItemProvider.container'
export default ItemProvider
